import { showLoading, hideLoading } from 'react-redux-loading-bar';

import { loginApi } from '../api/login';

export const SET_AUTHED_USER = 'SET_AUTHED_USER';

function setAuthedUser (user, error=null) {
    return {
        type: SET_AUTHED_USER,
        user,
        error
    }
}

export function handleSetAuthedUser () {
    return async (dispatch) => {
        dispatch(showLoading())
        try {
            const user = await localStorage.getItem('authedUser');
            if (user && user !== null) {
                dispatch(setAuthedUser(JSON.parse(user)));
                dispatch(hideLoading())
            } else {
                dispatch(setAuthedUser(null, "Not authorized"));
                dispatch(hideLoading())
            }
        } catch (error) {
            dispatch(setAuthedUser(null, error));
            dispatch(hideLoading())
        }
    }
}

export function handleSignIn (email,password) {
    return async (dispatch) => {
        // dispatch(showLoading())
        try {
            const result = await loginApi({email,password})
            if(result){
                let admin=result.data.data
                localStorage.setItem("authedUser",JSON.stringify(admin))

                // dispatch(hideLoading())
                return dispatch(setAuthedUser(admin));
            }
        } catch (error) {
            // dispatch(hideLoading())
            return dispatch(setAuthedUser(null, error));
        }
        
    }
}

// export function handleLogout () {
//     return async (dispatch) => {
//         await logout();
//         return dispatch(setAuthedUser(null));
//     }
// }